  <div class="page-header">
    <div class="page-header-title">{{ 'title.centers' | translate }}</div>
    <div class="page-header-search flex gap-2">
      <app-search-field></app-search-field>
      <p-button icon="pi pi-plus" class="add-button add-button-white" rounded (click)="addCenter()"
        [pTooltip]="'button.new-center' | translate" tooltipEvent="hover" tooltipPosition="top" />
    </div>
  </div>
  <p-table
    [value]="centers()"
    [rows]="10"
    [paginator]="true"
    [loading]="loadingCenters"
    [style]="{ width: '100%' }"
    [paginatorDropdownAppendTo]="'body'"
    [rowsPerPageOptions]="[10, 25, 50]"
    stripedRows
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="name">{{ 'field.center' | translate }}</th>
        <th pSortableColumn="town">{{'field.town' | translate}}</th>
        <th pSortableColumn="province">{{ 'field.province' | translate }}</th>
        <th style="width: 5rem"></th>
      </tr>
    </ng-template>
    <ng-template #body let-center>
      <tr>
        <td>{{ center.name }}</td>
        <td>{{ center.town }}</td>
        <td>{{ center.province }}</td>
        <td>
          <div class="flex items-center justify-center gap-2">
            <p-button icon="pi pi-pencil" severity="secondary" rounded 
              [pTooltip]="'button.edit' | translate" tooltipPosition="top"
              (click)="gotoDetail(center.id)"></p-button>
            <p-button icon="pi pi-trash" rounded severity="danger"
              [pTooltip]="'button.delete' | translate" tooltipPosition="top"
              (click)="deleteCenter($event, center)"></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">{{ 'no-item.centers' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>

  <p-confirmpopup />
